import React from 'react';
import { Outlet } from 'react-router-dom';

import FindVetBlock from '@app/components/UI/FindVetBlock/FindVetBlock';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import ScrollToTop from '@app/components/UI/ScrollToTop/ScrollToTop';

import '@app/scss/components/chat.scss';
import '@app/scss/style.scss';

interface PageProps {
	withScrollTop?: boolean;
	showFooter?: boolean;
	showFindVetBlock?: boolean;
}

const Layout: React.FC<PageProps> = ({ withScrollTop = true, showFooter = true, showFindVetBlock = true }) => {
	return (
		<div className="app-container">
			<Header />

			<div className="app-container-content">
				<Outlet />
			</div>

			{showFindVetBlock && <FindVetBlock />}
			{showFooter && <Footer />}
			{withScrollTop && <ScrollToTop />}
		</div>
	);
};

export default Layout;
